
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host ul{
    display:grid;
    width:100%;
    list-style-type:none;
    grid-template-columns:1fr 1fr 1fr 1fr 1fr 0fr;
    grid-row-gap:1rem;
    padding:0;
  }

    @media (min-width: 640px){:host ul{
      display:flex;
      justify-content:space-between;
      column-gap:0
  }
    }
  :host a{
    text-decoration:none;
    z-index:1;
  }
  :host .no-results,
  :host .yes-results{
    font-size:var(--fs-lg-mobile);
  }
  @media (min-width: 768px){
  :host .no-results,
  :host .yes-results{
      font-size:var(--fs-lg)
  }
    }
  :host .no-results{
    color:var(--gray-400);
  }
  :host .yes-results a{
    color:var(--brand-neutral-white);
  }
  :host .is-active{
    position:relative;
    color:var(--neutral-black) !important;
  }
  :host .is-active:after{
      content:'';
      position:absolute;
      width:1.25em;
      height:1.25em;
      background-color:var(--brand-neutral-white);
      border-radius:50%;
      left:calc(1em * -0.3);
      top:0;
      z-index:-1 !important;
    }
`;